import {
  Box,
  Checkbox,
  Container,
  Heading,
  HStack,
  PinInput,
  Flex,
  PinInputField,
  Text,
  Center,
  Button,
  // background,
} from '@chakra-ui/react'
import PanVerificationHeader from 'Components/Headers/PanVerificationHeader'
import Layout from 'Components/Layout'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useUpdatePanMutation, useUploadNocDocumentMutation } from 'Services/API/posp.api'
import { Link, useNavigate } from 'react-router-dom'
import CustomButton from 'Components/CustomButton'
import NocUpload from './NocUpload'
import { USER_REGISTRATION_TYPE } from 'Constants'
import { ToastService } from 'Services/toast.service'
import { updatePanNumber } from 'features/Authentication'
import { updateUserPospStatus, updateUserState } from 'features/Authentication/user.slice'
import { userState } from 'Constants/userRegistrationStatus'
import { useDeviceType } from 'app/hooks'

// CVKPR8232F

const PanVerification = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isMobile } = useDeviceType()
  const store = useSelector((state: any) => state.user)
  const { isRegistered } = store
  const [panNumber, setPanNumber] = useState('')
  const [hiddenPanNumber, setHiddenPanNumber] = useState('')
  const [panAlreadyExists, setPanAlreadyExists] = useState(false)
  const [agreementCheckbox, setAgreementCheckbox] = useState(false)
  const [userStateLoading, setUserStateLoading] = useState(false)
  const [isNocUploaded, setIsNocUploaded] = useState(false)
  const [nocPreview, setNocPreview] = useState<any>(null)
  const [noc, setNoc] = useState<any>(null)
  const [privacyPolicyClicked, setPrivacyPolicyClicked] = useState(false)
  const [tcClicked, setTcClicked] = useState(false)
  const [
    updatePanUpload,
    // {
    //   isLoading: personalDetailsUploadLoading,
    //     isError: personalDetailsUploadError,
    // },
  ] = useUpdatePanMutation()

  const [uploadNocDocument] = useUploadNocDocumentMutation()

  // console.log('is loading: ', userStateLoading);

  const handlePanVerify = async () => {
    // if (!tcClicked) {
    //   ToastService.showInfoToast({ title: 'Info', message: 'Please read terms and conditions' })
    //   return
    // }
    // if (!privacyPolicyClicked) {
    //   ToastService.showInfoToast({ title: 'Info', message: 'Please read privacy policy' })
    //   return
    // }
    setUserStateLoading(true)
    try {
      const resp: any = await updatePanUpload({
        pan_number: panNumber,
        already_registered: 0,
      }).unwrap()

      setUserStateLoading(false)

      if (resp.status === 200 && resp.message.toLowerCase() === 'success') {
        // redirect to training modulde
        ToastService.showSuccessTaost({ title: 'success', message: 'Data saved successfully' })
        dispatch(updatePanNumber(panNumber))
        navigate('/registration-status')
        dispatch(updateUserState(userState))
        dispatch(updateUserPospStatus(USER_REGISTRATION_TYPE.notRegistered))
      }
      // else {
      //   const hiddenPan = 'XXXXX' + panNumber.slice(5, 9) + 'X'
      //   setAgreementCheckbox(false)
      //   setHiddenPanNumber(hiddenPan)
      //   setPanAlreadyExists(true)
      //   dispatch(updateUserPospStatus(USER_REGISTRATION_TYPE.registered))
      //   dispatch(updateUserState(userState))
      // }
    } catch (error: any) {
      if (error?.data?.data?.pan_number) {
        if (error.data.data.pan_number?.[0]?.includes('delinked from another organization')) {
          const hiddenPan = 'XXXXX' + panNumber.slice(5, 9) + 'X'
          // setAgreementCheckbox(false)
          // setHiddenPanNumber(hiddenPan)
          setPanAlreadyExists(true)
          setUserStateLoading(false)
          dispatch(updateUserPospStatus(USER_REGISTRATION_TYPE.registered))
          dispatch(updateUserState(userState))
        }
        ToastService.showErrorToast({
          title: 'Error',
          message: error?.data?.data?.pan_number?.[0],
        })
      } else {
        ToastService.showErrorToast({ title: 'Error', message: error?.data?.message })
      }
      //  else {
      //   const hiddenPan = 'XXXXX' + panNumber.slice(5, 9) + 'X'
      //   // setAgreementCheckbox(false)
      //   setHiddenPanNumber(hiddenPan)
      //   setPanAlreadyExists(true)
      //   setUserStateLoading(false)
      //   dispatch(updateUserPospStatus(USER_REGISTRATION_TYPE.registered))
      //   dispatch(updateUserState(userState))
      // }
      setUserStateLoading(false)
    }
  }

  const handleFinalVerify = async () => {
    // if (!tcClicked) {
    //   ToastService.showInfoToast({ title: 'Info', message: 'Please read terms and conditions' })
    //   return
    // }
    // if (!privacyPolicyClicked) {
    //   ToastService.showInfoToast({ title: 'Info', message: 'Please read privacy policy' })
    //   return
    // }

    try {
      const formData = new FormData()
      formData.append('noc_file', noc)
      formData.append('pan_number', panNumber)
      const resp: any = await uploadNocDocument(formData).unwrap()
      if (resp.status === 200) {
        ToastService.showSuccessTaost({ title: 'success', message: resp.message })
        setIsNocUploaded(true)
        navigate('/registration-status')
      }
    } catch (err) {
      console.log(err)
    }

    // if (isNocUploaded) {
    //   ToastService.showSuccessTaost({ title: 'success', message: 'Data saved successfully' })
    //   navigate('/registration-status')
    // }
  }

  return (
    <Layout HeaderComponent={<PanVerificationHeader />}>
      <Container maxWidth='95%' py='10'>
        <Heading as='h4' size='xs'>
          Please provide PAN details for verification
        </Heading>

        <Box width={isMobile ? 'full' : '50%'} pt='10'>
          <Heading size='sm'>PAN Number</Heading>

          <HStack mt='5'>
            <PinInput
              variant='outline'
              value={panNumber}
              onChange={(e) => {
                setPanNumber(e.toUpperCase())
                setPanAlreadyExists(false)
              }}
              type='alphanumeric'
            >
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
            </PinInput>
          </HStack>

          {/* {panAlreadyExists && isRegistered === USER_REGISTRATION_TYPE.notRegistered ? (
            <Flex flexDir='column' alignItems='center'>
              <Box
                mt={4}
                py={2}
                px={4}
                background={'#F8D7DA 0% 0% no-repeat padding-box'}
                border={'1px solid #F5C6CB'}
                borderRadius={4}
              >
                <Text fontSize={'sm'}>
                  PAN already exists with other organisation. Kindly proceed with already POSP
                  option
                </Text>
              </Box>
              <CustomButton
                handlerFunction={() => {
                  navigate('/sp-registration/is-registered/status')
                }}
                buttonColor='#93C025'
                buttonText='Already a POSP? Click here'
              />
            </Flex>
          ) : null} */}

          {panAlreadyExists ? (
            <NocUpload
              noc={noc}
              setNoc={setNoc}
              nocPreview={nocPreview}
              setNocPreview={setNocPreview}
              setIsNocUploaded={setIsNocUploaded}
            />
          ) : null}

          <Flex mt={5} alignItems='flex-start' overflowY={'scroll'}>
            <Checkbox
              checked={agreementCheckbox}
              onChange={(e) => {
                // console.log(e.target.checked);
                setAgreementCheckbox(e.target.checked)
              }}
            />
            <Text ml={5} width='100%' color='#B5B5B5' textAlign='left' fontSize='xs'>
              By submitting the details, I override my NDNC registration and agree to be contacted
              by Zopper Insurance Brokers through call, e-mail, SMS, WhatsApp or other approved mode
              of communication. I further hereby provide my consent to Zopper Insurance Brokers and
              to share my information on a confidential basis with third parties solely in relation
              to evaluating and processing my application for becoming a POSP. I have read and agree
              to abide by the
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer', color: ' #0D7DD0' }}
                onClick={() => {
                  setPrivacyPolicyClicked(true)
                  window.open(
                    'https://foundation-dev.theblackswan.in/media/_cUDgs5s7BbQWQZE0D3CjA==.pdf',
                  )
                }}
              >
                {' '}
                Privacy policy{' '}
              </a>{' '}
              and
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer', color: ' #0D7DD0' }}
                onClick={() => {
                  setTcClicked(true)
                  window.open(
                    'https://foundation-dev.theblackswan.in/media/pIPa4tZKTcySscK98akRrQ==.pdf',
                  )
                }}
              >
                {' '}
                Terms & Conditions{' '}
              </a>{' '}
              of the Company
            </Text>
          </Flex>
        </Box>
        <Center>
          <Button
            isDisabled={
              panNumber.length !== 10 || (panAlreadyExists && !isNocUploaded) || !agreementCheckbox
            }
            mt={15}
            colorScheme='#153467'
            // color='#153467'
            loadingText='Please Wait....'
            variant={'solid'}
            // _hover = {background:''}
            rounded={'full'}
            fontSize='xs'
            fontWeight='semibold'
            background={'#153467'}
            paddingX={7}
            isLoading={userStateLoading}
            onClick={panAlreadyExists ? handleFinalVerify : handlePanVerify}
          >
            VERIFY
          </Button>
        </Center>
      </Container>
    </Layout>
  )
}

export default PanVerification
